import React from "react";
import { observer } from "mobx-react";

import { TeamStatistics } from "@gp/models";

export const Corners = observer(function Corners({
	homeStats,
	awayStats,
}: {
	homeStats: TeamStatistics | undefined;
	awayStats: TeamStatistics | undefined;
}) {
	if (homeStats?.cornerKicks == null && awayStats?.cornerKicks == null) {
		return null;
	}

	return (
		<div className="event__stats__item">
			<div className="event__stats__icon">
				<i className="u-icon u-icon--sml u-icon--corner" />
			</div>
			<div className="event__stats__value">
				<span>{homeStats?.cornerKicks || 0}</span>
				<span> - </span>
				<span>{awayStats?.cornerKicks || 0}</span>
			</div>
		</div>
	);
});
